import { ErrorHandler, Injectable, NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import {TranslateModule, TranslatePipe} from '@ngx-translate/core';
import { FuseModule } from '@fuse/fuse.module';
import { FuseProgressBarComponent } from '@fuse/components/progress-bar/progress-bar.component';


import { HighchartsChartModule } from 'highcharts-angular';
import * as Hammer from 'hammerjs';

import { fuseConfig } from 'app/fuse-config';
import { FakeDbService } from 'app/fake-db/fake-db.service';
import { AppComponent } from 'app/app.component';
import { AppStoreModule } from 'app/store/store.module';
import { LayoutModule } from 'app/layout/layout.module';

import { ClientErrorHandler } from '../@tpl-core/interceptors/error-handler.service';
import { UserDetailsResolverService } from '../@tpl-auth/services/user-details-resolver.service';
import { ResponseHandlerInterceptor } from '../@tpl-core/interceptors/response-handler-interceptor';
import { AuthGuard } from '../@tpl-core/guards/auth/auth.guard';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SnackBarService } from '../@ksm-core/shared/components/snackbar/snack-bar.service';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'ksm/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'apps',
    loadChildren: () => import('./main/apps/apps.module').then(m => m.AppsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('../@tpl-auth/tpl-auth.module').then(m => m.TplAuthModule)
  },
  {
    path: 'pages',
    loadChildren: () => import('./main/pages/pages.module').then(m => m.PagesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'ui',
    loadChildren: () => import('./main/ui/ui.module').then(m => m.UIModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'documentation',
    loadChildren: () => import('./main/documentation/documentation.module').then(m => m.DocumentationModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'style-guide',
    loadChildren: () => import('./style-guide/style-guide.module').then(m => m.StyleGuideModule)
  },
  {
    path: 'ksm',
    data: {
      breadcrumb: 'Ksm'
    },
    loadChildren: () => import('../@ksm/ksm.module').then(m => m.KsmModule),
    canActivate: [AuthGuard],
    resolve: { currentUser: UserDetailsResolverService }
  },
  { path: '**',
    redirectTo: 'ksm/dashboard?customerName=All' }
];

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  overrides = {
    swipe: { direction: Hammer.DIRECTION_ALL }
  };
}


